import React, { useState } from 'react'
import { Alert, Button, Form, Input, Typography } from 'antd'
import {
  ArrowRightOutlined,
  BarChartOutlined,
  CloudServerOutlined,
  LockOutlined,
  SafetyCertificateOutlined,
  UserOutlined
} from '@ant-design/icons'
import { useAuth } from '../../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'
import './LoginPage.css'

const { Title, Text } = Typography

const LoginPage = () => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const { login } = useAuth()
  const navigate = useNavigate()

  const handleSubmit = async values => {
    setLoading(true)
    setError('')
    try {
      const result = await login(values)
      if (result.success) navigate('/dashboard', { replace: true })
      else setError(result.message || 'อีเมลหรือรหัสผ่านไม่ถูกต้อง')
    } catch (loginError) {
      setError(loginError?.response?.data?.message || 'ไม่สามารถเข้าสู่ระบบได้ กรุณาลองใหม่อีกครั้ง')
    } finally {
      setLoading(false)
    }
  }

  return (
    <main className="erp-login-page">
      <section className="erp-login-showcase" aria-label="ข้อมูลระบบ">
        <div className="erp-login-showcase-glow erp-login-glow-one" />
        <div className="erp-login-showcase-glow erp-login-glow-two" />

        <div className="erp-login-brand">
          <div className="erp-login-logo"><BarChartOutlined /></div>
          <div>
            <div className="erp-login-brand-name">ATOMSOFT ERP</div>
            <div className="erp-login-brand-caption">Business Management Platform</div>
          </div>
        </div>

        <div className="erp-login-showcase-content">
          <span className="erp-login-eyebrow">ENTERPRISE RESOURCE PLANNING</span>
          <h1>บริหารธุรกิจอย่างเป็นระบบ<br />พร้อมข้อมูลที่ตัดสินใจได้จริง</h1>
          <p>รวมงานขาย ค่าใช้จ่าย สต็อก บัญชี และรายงานทางการเงินไว้ในพื้นที่ทำงานเดียว</p>

          <div className="erp-login-benefits">
            <div><SafetyCertificateOutlined /><span><b>ปลอดภัย</b><small>ควบคุมสิทธิ์ผู้ใช้งานด้วย RBAC</small></span></div>
            <div><CloudServerOutlined /><span><b>พร้อมใช้งานทุกที่</b><small>เข้าถึงเอกสารและข้อมูลผ่านระบบ Cloud</small></span></div>
            <div><BarChartOutlined /><span><b>เห็นภาพรวมชัดเจน</b><small>วิเคราะห์รายได้ ต้นทุน และกำไรแบบครบวงจร</small></span></div>
          </div>
        </div>

        <div className="erp-login-showcase-footer">© {new Date().getFullYear()} Atomsoft Co., Ltd. All rights reserved.</div>
      </section>

      <section className="erp-login-panel">
        <div className="erp-login-mobile-brand">
          <div className="erp-login-logo"><BarChartOutlined /></div>
          <div><b>ATOMSOFT ERP</b><small>Business Management Platform</small></div>
        </div>

        <div className="erp-login-card">
          <div className="erp-login-heading">
            <span className="erp-login-welcome-icon"><LockOutlined /></span>
            <Title level={2}>เข้าสู่ระบบ</Title>
            <Text>เข้าสู่ระบบเพื่อจัดการธุรกิจของคุณ</Text>
          </div>

          {error && <Alert className="erp-login-alert" type="error" showIcon message={error} closable onClose={() => setError('')} />}

          <Form form={form} name="login" layout="vertical" onFinish={handleSubmit} requiredMark={false} size="large">
            <Form.Item name="email" label="อีเมล" rules={[
              { required: true, message: 'กรุณาระบุอีเมล' },
              { type: 'email', message: 'รูปแบบอีเมลไม่ถูกต้อง' }
            ]}>
              <Input prefix={<UserOutlined />} placeholder="name@company.com" autoComplete="email" autoFocus />
            </Form.Item>

            <Form.Item name="password" label="รหัสผ่าน" rules={[{ required: true, message: 'กรุณาระบุรหัสผ่าน' }]}>
              <Input.Password prefix={<LockOutlined />} placeholder="กรอกรหัสผ่านของคุณ" autoComplete="current-password" />
            </Form.Item>

            <Button className="erp-login-submit" type="primary" htmlType="submit" loading={loading} block>
              <span>{loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}</span>
              {!loading && <ArrowRightOutlined />}
            </Button>
          </Form>

          <div className="erp-login-security"><SafetyCertificateOutlined /> การเชื่อมต่อของคุณได้รับการเข้ารหัสและปกป้องอย่างปลอดภัย</div>
        </div>

        <div className="erp-login-mobile-footer">พัฒนาโดย บริษัท อะตอมซอฟท์ จำกัด</div>
      </section>
    </main>
  )
}

export default LoginPage
